import controller from './labels.controller';

const template = require('./labels.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/labels.component.js